import { useState, useEffect, useContext } from "react";
import { Menu, UserCircle, Lock, LogOut, ChevronDown } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { RootContext } from "../../context";

const Header = ({toggleSidebar}: any) => {
  const { authStore } = useContext(RootContext);
  const { logout } = authStore;
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleClickOutside = (event: MouseEvent) => {
    if (
      !(event.target as HTMLElement).closest(".menu-button") &&
      !(event.target as HTMLElement).closest(".dropdown-menu")
    ) {
      setIsOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login')
      
    } catch (error: any) {
      console.error(error);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="sticky top-0 z-40 flex justify-between items-center h-16 px-6 bg-white border-b border-gray-200/80 shadow-sm backdrop-blur-sm">
      <Link to="/" className="group">
        <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent transition-all duration-200 group-hover:from-purple-700 group-hover:to-blue-700">
          Moti Alarm
        </h1>
      </Link>
      
      <div className="relative flex gap-2 items-center">
        <button
          onClick={toggleMenu}
          className="menu-button group flex items-center gap-2 px-3 py-2 text-gray-700 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-200 hover:border-gray-300 transition-all duration-200 shadow-sm"
        >
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center text-white shadow-md">
            <UserCircle className="w-5 h-5" />
          </div>
          <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
        </button>
        
        <button
          onClick={toggleSidebar}
          className="md:hidden p-2.5 text-gray-700 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-200 hover:border-gray-300 transition-all duration-200 shadow-sm"
        >
          <Menu className="w-5 h-5" />
        </button>
        
        {isOpen && (
          <div className="dropdown-menu absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 shadow-xl rounded-xl overflow-hidden z-50 animate-in fade-in slide-in-from-top-2 duration-200">
              <div className="p-3 border-b border-gray-100 bg-gradient-to-br from-gray-50 to-white">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center text-white shadow-md">
                    <UserCircle className="w-6 h-6" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-900">Account</p>
                    <p className="text-xs text-gray-500">Manage your account</p>
                  </div>
                </div>
              </div>
              
              <ul className="py-2">
                {/* <li>
                  <Link
                    to="/user/profile"
                    onClick={closeMenu}
                    className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150"
                  >
                    <User className="w-4 h-4 text-gray-400" />
                    <span className="font-medium">Profile</span>
                  </Link>
                </li> */}
                <li>
                  <Link
                    to="/change-password"
                    onClick={closeMenu}
                    className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150"
                  >
                    <Lock className="w-4 h-4 text-gray-400" />
                    <span className="font-medium">Change Password</span>
                  </Link>
                </li>
                <li className="border-t border-gray-100 mt-2 pt-2">
                  <button
                    onClick={() => handleLogout()}
                    className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors duration-150"
                  >
                    <LogOut className="w-4 h-4" />
                    <span className="font-medium">Logout</span>
                  </button>
                </li>
              </ul>
            </div>
        )}
      </div>
    </header>
  );
};

export default Header;